<script>
export default {
  name: 'IconFpGift',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3.5" y="8.5" width="17" height="4" rx="1" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12 8.5v12" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M19 12.5v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.5 8.5a2.5 2.5 0 0 1 0-5C11 3.5 12 8.5 12 8.5s1-5 4.5-5a2.5 2.5 0 0 1 0 5" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
